import React from 'react';
import i18next from 'i18next';
import { observer } from 'mobx-react';
import { staticURL } from 'core/url';
import { routerStore } from 'core';
import { clientStore } from 'apps/client/app';

type CancelledPlanProps = {
  style?: React.CSSProperties;
  className?: string;
  cancellationNotice?: React.ReactNode;
  isAdminAndPlanWasCanceled?: boolean;
};

export const CancelledPlanForTeam = observer(
  ({
    style = {},
    className = '',
    isAdminAndPlanWasCanceled,
    cancellationNotice = '',
  }: CancelledPlanProps) => {
    const navigateToSettingBilling = () => {
      const { spacePath, initiative } = routerStore.route.params;
      routerStore.navigate('workspace.spaceSettings.billing', {
        spacePath: spacePath || initiative || clientStore.slugFromRouteOrSpace,
      });
    };

    return (
      <div
        style={{
          height: '80vh',
          ...style,
        }}
        className={`flex flex-col items-center w-full justify-center p-16 ${className}`}
      >
        <img className='pb-4' src={staticURL('assets/icons/snap.svg')} />
        {isAdminAndPlanWasCanceled ? (
          <p
            className='mt-2 text-black'
            data-testid='cancelledPlanForTeamAdmin-text'
          >
            {cancellationNotice || (
              <>
                Your plan has been canceled, please reactivate in the
                <a
                  className='cursor-pointer'
                  onClick={() => {
                    navigateToSettingBilling();
                  }}
                >
                  &nbsp;settings page
                </a>
              </>
            )}
          </p>
        ) : (
          <p
            className='mt-2 text-black'
            data-testid='cancelledPlanForTeam-text'
          >
            {cancellationNotice ||
              i18next.t(
                'You plan has been cancelled, please contact your Workspace Admin to reactivate it',
              )}
          </p>
        )}
      </div>
    );
  },
);
